/* import __COLOCATED_TEMPLATE__ from './sdr-trigger-info-node.hbs'; */
/* RESPONSIBLE TEAM: team-ml */
import templateOnlyComponent from '@ember/component/template-only';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface InfoPanelTriggerData {
  title: string;
  subtitle?: string;
  icon: InterfaceIconName;
}

interface Signature {
  Element: HTMLDivElement;
  Args: {
    infoPanelTriggerData: InfoPanelTriggerData;
  };
}

const SdrTriggerInfoNode = templateOnlyComponent<Signature>();
export default SdrTriggerInfoNode;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::SalesDevelopment::SdrTriggerInfoNode': typeof SdrTriggerInfoNode;
    'ai-agent/sales-development/sdr-trigger-info-node': typeof SdrTriggerInfoNode;
  }
}
